import React, { useEffect, useState } from 'react';
import { getStatsAsync } from '../../Services/AdminService';
import CourseStats from '../../Shared/Components/StatCard/CourseStats';
import Header from './../../Shared/Components/Header/Header';
import StatCard from './../../Shared/Components/StatCard/StatCard';
import './AdminDashboard.scss';

const AdminDashboard = () => {
    const [stats, setStats] = useState({ courses: [] });
    const palette = {
        clients: '#2563eb',
        learners: '#0f766e',
        courses: '#d97706',
        pathways: '#7c3aed',
        logins: '#0ea5e9',
        started: '#16a34a',
        completed: '#dc2626'
    };

    useEffect(() => {
        getDashboard();
    }, [])

    const getDashboard = async () => {
        let response = await getStatsAsync();
        setStats(response);
    }

    return (
        <div className="admin-dashboard">
            <Header heading="Dashboard" subheading="Current overview of the eLearning analytics" icon="bar-chart" />
            <div className="container-fluid content">
                <div className="row mb-4">
                    <div className="col-12">
                        <h5 className="section-title">Platform Overview</h5>
                    </div>
                </div>
                <div className="row g-3 mb-4">
                    <StatCard
                        title="Total Clients"
                        stat={stats.numberOfClients}
                        subtext="Active clients on platform"
                        icon="users"
                        colour={palette.clients}
                    />
                    <StatCard
                        title="Total Learners"
                        stat={stats.numberOfLearners}
                        subtext="Registered learners"
                        icon="user"
                        colour={palette.learners}
                    />
                    <StatCard
                        title="Total Courses"
                        stat={stats.numberOfCourses}
                        subtext="Available courses"
                        icon="graduation"
                        colour={palette.courses}
                    />
                    <StatCard
                        title="Learning Pathways"
                        stat={stats.numberOfPathways}
                        subtext="Structured learning paths"
                        icon="briefcase"
                        colour={palette.pathways}
                    />
                </div>

                <div className="row mb-4">
                    <div className="col-12">
                        <h5 className="section-title">This Month's Activity</h5>
                    </div>
                </div>
                <div className="row g-3 mb-4">
                    <StatCard
                        title="User Logins"
                        stat={stats.numberOfLoginsThisMonth}
                        subtext="Total logins this month"
                        icon="enter"
                        colour={palette.logins}
                    />
                    <StatCard
                        title="Courses Started"
                        stat={stats.coursesStartedThisMonth}
                        subtext="New course enrollments"
                        icon="play"
                        colour={palette.started}
                    />
                    <StatCard
                        title="Courses Completed"
                        stat={stats.coursesCompletedThisMonth}
                        subtext="Successful completions"
                        icon="checkmark"
                        colour={palette.completed}
                    />
                </div>

                <div className="row">
                    <div className="col-12">
                        <h5 className="section-title mb-3">Course Statistics</h5>
                    </div>
                    <CourseStats courses={stats.courses} />
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;